export const SESSION_COOKIE_NAME = "rr_session";

export const COOKIE_OPTIONS = {
    httpOnly: true,
    secure: process.env.NODE_ENV === "production",
    sameSite: "lax" as const,
    path: "/",
    // 7 days
    maxAge: 7 * 24 * 60 * 60,
};
